// extracted by css-extract-rspack-plugin
export default {"root":"UploadImage_root__icDxx","actionsWrapper":"UploadImage_actionsWrapper__5sd6m","disabled":"UploadImage_disabled__8rPAp"};